import { render, staticRenderFns } from "./CompanyIntegrationSetting.vue?vue&type=template&id=323fee32&scoped=true"
import script from "./CompanyIntegrationSetting.vue?vue&type=script&lang=js"
export * from "./CompanyIntegrationSetting.vue?vue&type=script&lang=js"
import style0 from "./CompanyIntegrationSetting.vue?vue&type=style&index=0&id=323fee32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323fee32",
  null
  
)

export default component.exports